import { RootState } from './../redux/store';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  ICity,
} from '../models/ICity/ICity';
import { API_BASE_URL } from '../helpers/common';

export const citiesApi = createApi({
  reducerPath: 'citiesApi',
  tagTypes: ['City'],
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: async (headers, { getState }) => {
      const token = (getState() as RootState).user.info.accessToken;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getCities: build.query<ICity[], { language?: string } | void>({
      transformResponse: (response: { data: ICity[] }) =>  response.data,
      query: (params) => ({
        url: '/cities/list',
        method: 'GET',
        params: params || {},
      }),
    }),
    getCitiesShortList: build.query<{ id: number; name: string }[], any>({
      transformResponse: (response: { data: { id: number; name: string }[] }) =>
        response.data,
      query: () => ({
        url: '/cities/short-list',
        method: 'GET',
      }),
    }),
    getCityById: build.query<ICity, number>({
      transformResponse: (response: { data: ICity }) => response.data,
      query: (id) => ({
        url: `/cities/${id}`,
        method: 'GET',
      }),
    }),
    createCity: build.mutation<ICity, Partial<ICity>>({
      transformResponse: (response: { data: ICity }) => response.data,
      query: (data) => ({
        url: '/cities/create',
        method: 'POST',
        body: data,
      }),
    }),
    updateCity: build.mutation<ICity, { id: number; data: Partial<ICity> }>({
      transformResponse: (response: { data: ICity }) => response.data,
      query: ({ id, data }) => ({
        url: `/cities/${id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    deleteCity: build.mutation<{ success: boolean }, number>({
      query: (id) => ({
        url: `/cities/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetCitiesQuery,
  useGetCitiesShortListQuery,
  useGetCityByIdQuery,
  useCreateCityMutation,
  useUpdateCityMutation,
  useDeleteCityMutation,
} = citiesApi;
